import React from "react";
import { Input, Form } from "semantic-ui-react";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { debounce } from "lodash";
import ProcessingImageStore from "~/stores/ProcessingImageStore";

@observer
class ProcessingImageFilter extends React.Component {
  render() {
    const { processingImageStore, filterName, filterMinValue, filterMaxValue } = this.props;
    const { isImageLoading, filters, filtersBefore } = processingImageStore;
    const inputNameBefore = `filter-before-${filterName}`;
    const inputName = `filter-${filterName}`;

    return (
      <>
        <Form.Field inline>
          <label>{filterName.charAt(0).toUpperCase() + filterName.slice(1)}</label>
          <Input
            name={inputNameBefore}
            type="text"
            autoComplete="off"
            disabled={isImageLoading}
            value={filtersBefore[filterName]}
            onChange={event => processingImageStore.changeFilterBefore(filterName, event.target.value, filterMinValue)}
          />
        </Form.Field>
        <Form.Field>
          <Input
            step="1"
            min={filterMinValue}
            max={filterMaxValue}
            name={inputName}
            type="range"
            disabled={isImageLoading}
            value={filters[filterName]}
            onChange={debounce((event, data) => processingImageStore.changeFilter(filterName, data.value), 200)}
          />
        </Form.Field>
      </>
    );
  }
}

ProcessingImageFilter.propTypes = {
  processingImageStore: PropTypes.instanceOf(ProcessingImageStore),
  filterName: PropTypes.string.isRequired,
  filterMinValue: PropTypes.number.isRequired,
  filterMaxValue: PropTypes.number.isRequired,
};

export default ProcessingImageFilter;
